import Avatar from "@/components/Avatar";
import LineIcon from "@/components/icons/LineIcon";
import { useAppDispatch } from "@/redux/hooks/useTypedSelector";
import { selectCurrentUser } from '@/redux/selectors/authSelector';
import { logout } from "@/redux/slices/authSlice";
import { persistor } from '@/redux/store';

import {
  Dropdown,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "react-bootstrap";
import { useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";

const ProfileDropdown = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUser);

  const handleLogout = async () => {
    dispatch(logout());
    await persistor.purge();
    navigate("/", { replace: true });
  };

  const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");

  return (
    <Dropdown className="topbar-item">
      <DropdownToggle
        as="button"
        type="button"
        className="topbar-button topbar-avatar content-none"
        id="page-header-user-dropdown "
        aria-label="Account menu"
      >
        <Avatar name={displayName} fallback={user?.email} />
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownHeader as={"h6"} className="dropdown-header">
          Welcome {user?.firstName}!
        </DropdownHeader>
        <DropdownItem as={Link} to="/profile">
          <LineIcon name="user" size={17} />
          <span>Profile</span>
        </DropdownItem>

        <div className="dropdown-divider my-1" />
        <DropdownItem
          as="button"
          className="text-danger"
          onClick={handleLogout}
        >
          <LineIcon name="log-out" size={17} />
          <span>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
